import { proxy, snapshot, useSnapshot } from "@web-monorepo/hooks";
import { Display, IdeasState, initialIdeasState } from ".";

const store = proxy<IdeasState>({
  display: { ...initialIdeasState.display },
});

export const toolkitIdeasActions = {
  mergeDisplay(payload: Partial<Display>) {
    Object.assign(store.display, payload);
  },
};

export function useToolkitIdeasStore() {
  return useSnapshot(store);
}

export function getToolkitIdeasState() {
  return snapshot(store);
}

export function resetToolkitIdeasStore() {
  Object.assign(store.display, initialIdeasState.display);
}
